import { render, staticRenderFns } from "./AddStudentPayForCourse.vue?vue&type=template&id=05a39d4a&scoped=true&"
import script from "./AddStudentPayForCourse.vue?vue&type=script&lang=js&"
export * from "./AddStudentPayForCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a39d4a",
  null
  
)

export default component.exports